import { APIClient } from "./api_frontend_helper";

import * as url from "./url_frontend_helper";

const api = new APIClient();

// Messages
export const getMessages = caseExtId => api.get(url.MESSAGES, caseExtId); //GET
export const sendMessage = messageData => api.create(url.MESSAGES, messageData);
export const setMessageRead = messageId => api.update(url.MESSAGES + '/' + messageId, { isRead: true });

// Product
export const getActiveProducts = () => api.get(url.PRODUCTS);